<template>
  <div class="broadcast-right-bottom-message chat_box">
    <!-- 用户聊天 -->
    <div class="broadcast-right-bottom-message-message">
      <div class="user_chat">
        <span class="user_name"> 系统提示 </span>
        <span class="user_content">
          {{noticeTxt}}
        </span>
      </div>
    </div>
    <div class="broadcast-right-bottom-message-message">
      <div @click="openCard(item.currentUser.uid)" class="chatlabel_history" v-for="(item, index) in historyMsg" :key="'info2-' + index">
        <div v-if="item.currentUser" class="user_chat">
          <!-- 用户标签 -->
          <div class="labelBox" v-if="
              item &&
              item.currentUser &&
              item.currentUser.level
            ">
            <div class="user_newGreeds_bigs"
              v-if="roomInfoData.user && roomInfoData.user.uid  ==  item.currentUser.uid">
              <img src="/static/newhome/nezha.webp" alt="" />
            </div>
            <div class="user_newGreeds_bigs" v-else-if="item && item.currentUser && item.currentUser.role >= 2">
              <img src="/static/newhome/xiabing.webp" alt="" v-if="item.currentUser.role  == 2" />
              <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.currentUser.role  == 4" />
            </div>
            <div class="user_newGreeds" v-else>
              <img :src="'/static/newhome/b' +  fifLabelName( item.currentUser.level).bg + '.webp' " alt="" />
            </div>
            <!-- 粉丝团标签 -->
            <div class="new_fansIcon" v-if="item.fans && item.fans.level !=0">
              <img :src="'/static/newhome/f'+(item.fans.level  )+'.webp'" alt="">
              <span>{{item.fans.name?item.fans.name:roomInfoData.user.nickname.slice(0,3)}}</span>
            </div>
            <!-- 用户等级 -->
            <div class="user_newGreeds" v-if="item && item.currentUser && item.currentUser.level">
              <img :src="
                 '/static/newhome/l' +
                   item.currentUser.level +
                   '.webp'
               " alt="" />
            </div>
          </div>
          <span class="user_name" style="color: #2C62CF;" v-if="item.currentUser && item.currentUser.nickname">
            {{ item.currentUser.nickname }}:
          </span>
          <span class="user_content" v-if="item.message && item.message.content ">
            {{ item.message.content }}
          </span>
          <!-- 系统提示 -->
          <span class="user_content" style="color: #999;" v-if="item.message.systemtext">
            <span class="user_name" style="color: #2C62CF;">系统提示</span> {{ item.message.systemtext }}
          </span>
        </div>
      </div>
      <div @click="openCard(item.message.currentUser.uid)" class="chatlabel_newMessage" v-for="(item, index) in newmessage" :key="index">
        <!-- 用户发送弹幕 -->
        <div v-if="item.messageType === 10003">
          <!-- @click="TraCQ(item.message.currentUser.uid)" -->
            <!-- 用户标签 -->
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
                <span  class="user_content" v-if="item.message.message">
                  {{ item.message.message.content }}
                </span>
            </chatlabelItem>

        </div>
        <div v-if="item.messageType === 10001">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <span class="user_content" style="color: #999999">
               欢迎进入直播间</span>
            </chatlabelItem>

        </div>
        <div v-if="item.messageType === 10013">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <span class="user_content" style="color: #999999">
                关注了主播</span>
            </chatlabelItem>

        </div>
        <div class="user_liwu" v-if="item.messageType === 10004">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <div class="user_content_liwu">送的&nbsp;<span>{{ item.message.gift.giftName }}</span></div>
              <div style="display: inline;">
                <img style="width: 32px;height: 32px;vertical-align: bottom;" :src="item.message.gift.msgIcon"
                  alt="" />
                <div style="color: rgba(255, 0, 0, 1.0);display: inline;">
                  x{{ item.message.gift.num }}
                </div>
              </div>
            </chatlabelItem>

        </div>
        <div class="user_chat" v-if="item.messageType === 10007">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <span class="user_content" style="color: #ED1010">已被禁言</span>
            </chatlabelItem>
        </div>
        <div class="user_chat" v-if="item.messageType === 10010">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <span class="user_content" style="color: #ED1010">已被封禁</span>
            </chatlabelItem>
        </div>
        <div class="user_chat"  v-if="item.messageType === 10404 && item.message.type != 2">
           <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
             <span>成为粉丝团的第{{ item.message.fansNums}}位粉丝</span>
           </chatlabelItem>
        </div>
        <div class="user_chat" v-if="item.messageType === 10404 && item.message.type == 2">
            <chatlabelItem :roomData='roomInfoData' :chatItem='item'>
              <span class="user_content" style="color: #999999">  {{item.message.content}}</span>
            </chatlabelItem>
        </div>
        <div class="user_chat" v-if="item.messageType === 10405 && item.message.type == 2">
          <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message">
            恭喜 <span style="color: #2C62CF;"> {{item.message.fansUserData.nickname}}</span> 粉丝团勋章升级
          </div>
        </div>
        <!-- 系统提示 -->
        <div class="user_chat" v-if="item.messageType === 11111">
          <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message">
            <!-- 系统提示 -->
            <span class="user_name" style="color: #2C62CF;">系统提示</span> {{ item.message.content }}
          </div>
        </div>
      </div>
    </div>
    <roledialog2 ref="roledialog"></roledialog2>
  </div>
</template>

<script>
import chatlabelItem from './lz_chatlabelItem.vue';
  import roledialog2 from './lz_roledialog2.vue';
  export default {
    components: {
      chatlabelItem,
      roledialog2
    },
    props:{
      roomId:{
        type:String,
        default:()=>{
          return ''
        }
      },
      historyMsg:{
        type:Array,
        default:()=>{
          return []
        }
      },
      newmessage:{
        type:Array,
        default:()=>{
          return []
        }
      },
      roomInfoData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      noticeTxt:{
        type:String,
        default:()=>{
          return ''
        }
      }
    },
    data() {
      return {
        message1: [],
        sendMessage: '',
        quanxian: '',
        tracq: '',
        oneselfTracq: false,
        curUserInfo:{},
      }
    },
    methods: {
      // 等级标签
      fifLabelName(v){
        let obj = {};
        if (v >= 1 && v <= 3) {
          obj.name = '鳜都司'
          obj.bg = 1
        } else if (v >= 4 && v <= 6) {
          obj.name = '鳜少卿'
          obj.bg = 2
        } else if (v >= 7 && v <= 9) {
          obj.name = '鲌太尉'
          obj.bg = 3
        } else if (v >= 10 && v <= 12) {
          obj.name = '鲭太尉'
          obj.bg = 4
        } else if (v >= 13 && v <= 15) {
          obj.name = '鳝力士'
          obj.bg = 5
        } else if (v >= 16 && v <= 18) {
          obj.name = '鯾提督'
          obj.bg = 6
        } else if (v >= 19 && v <= 21) {
          obj.name = '鲤总兵'
          obj.bg = 7
        } else if (v >= 22 && v <= 24) {
          obj.name = '鲤元帅'
          obj.bg = 8
        } else if (v >= 25 && v <= 27) {
          obj.name = '鲤太宰'
          obj.bg = 9
        } else if (v >= 28 && v <= 30) {
          obj.bg = 10
          obj.name = '鱑把总'
        } else if (v >= 31 && v <= 33) {
          obj.name = '机巧鼋'
          obj.bg = 11
        } else if (v >= 34 && v <= 36) {
          obj.name = '玄微鬼'
          obj.bg = 12
        } else if (v >= 37 && v <= 39) {
          obj.name = '亀丞相'
          obj.bg = 13
        } else if (v >= 40 && v <= 42) {
          obj.name = '鲇外郎'
          obj.bg = 14
        } else if (v >= 43) {
          obj.name = '鲫军师'
          obj.bg = 15
        } else {
          obj.name = false
          obj.bg = false
        }
        return obj
      },
      denglu() {
        console.log('登录方法');
      },
      openCard(uid){
        this.$refs.roledialog.open({
          roomId:this.roomId,
          uid:uid,
        })
      },
      // 点击name获取名片
      TraCQ(uid) {
        if (!this.sendMessage) {
          this.denglu()
          return
        }

        if (this.oneselfTracq == true || this.tracq == true) {
          console.log("已经打开名片");
        } else {
          // 用户信息接口
          this.$axios
            .get(this.api + "/v1/profile/user", {
              params: {
                uid: uid,
              },
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
              },
            })
            .then((res) => {
              this.curUserInfo   = res.data.data;
            });

          if (this.a.userid == uid) {
            this.oneselfTracq = true;
          } else {
            this.Operation(uid);
          }
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .broadcast-right-bottom-message {
    height: 100%;
    min-width: 17.9vw !important;
    box-sizing: border-box;
    /* padding: 0 5%; */
    overflow-y: scroll;
    /* background-color: red; */
    position: relative;
  }
  .broadcast-right-bottom-message-message {
    width: 89%;
    margin-bottom: 2px;
    position: relative;
    .user_newGreeds_bigs{
      display: inline-block;
      height: 14px;
      width: 24px;
      img{
        height: 14px;
        width: 24px;
      }
    }
    .user_content {
       font-size: 14px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       cursor: pointer;
       color: #666666;
       word-wrap: break-word;
       word-break: normal;
       line-height: 30px;
     }

     .user_name {
       font-size: 14px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       color: #2C62CF !important;
       height: 30px;
       line-height: 30px;
       cursor: pointer;

     }
      .user_content_liwu {
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        word-wrap: break-word;
        word-break: normal;
        line-height: 30px;
        color: #666;
        display: inline;
        span {
          color: #666;
          margin: 4px;
        }
      }
    .user_greds {
      display: inline-flex;
      align-items: center;
      margin-right: 4px;
      height: 18px;
      img {
        width: 40px;
        height: 18px;
      }
    }

     .user_chat {
       vertical-align: text-bottom;
       // display: inline-flex;
       // align-items: flex-start;
     }
    .user_fansIcon{
      height: 14px;
      min-width:53px;
      position: relative;
      display: inline-flex;
      align-self: center;
      align-items: center;
      box-sizing: border-box;
      vertical-align:middle;
      position: relative;
      img{
        position: absolute;
        left: 0;
        top: 0;
        min-width:53px;
        height: 14px;
        z-index:1;
      }
      span{
        z-index:2;
        position: absolute;
        right: 2px;
        font-size:8px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff557f;
      }
    }
    .new_fansIcon{
      display: inline-block;
      height: 14px;
      width: 56px;
      position: relative;
      border-radius:2px;
      span{
        position: absolute;
        color: #fff;
        right: 2px;
        font-size: 12px;
        top: 50%;
        height: 12px;
        transform: translateY(-50%);
      }
      img{
        height: 14px;
        width: 56px;
      }
    }
    .user_newGreeds{
      display: inline-block;
      height: 14px;
      width: 40px;
      img{
        height: 14px;
        width: 40px;
      }
    }
    .user_chat {
      vertical-align: text-bottom;
    }
    .labelBox{
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_chatlabel.vue